// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","image":"Card_image__VZTa-"};